export const hectoClientKey = process.env.REACT_APP_PG_HECTO_CLIENT_KEY